import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Todo } from '../../entities/Dayplan/DayplanTypes';
import { unwrap } from '../common/apiCommons';
import axios from 'axios';

export const DayplanMutations = {
  async deleteTodo(todoId: string, employeeId: string) {
    const res = await axios.delete<{}>(`/todos/${employeeId}/delete/${todoId}`);
    return unwrap(res);
  },
};

export const DayplanHooks = {
  useDeleteTodoMutation(employeeId: string) {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: (todo: Todo) =>
        DayplanMutations.deleteTodo(todo.id, employeeId),
      onSuccess: () => {
        queryClient.invalidateQueries(['todos', employeeId]);
      },
    });
  },
};

export const DayplanApi = {
  mutations: DayplanMutations,
  hooks: DayplanHooks,
};
